// Modelo User para administrador.
export default class User {
  id=""
  login=""
  firstName=""
  lastName=""
  email=""
  identification=""
  degree=""
  specialty=""
  position=""
  activated=true
  authorities=[]
  company=""
  photo=[]
}



// WEBPACK FOOTER //
// ./src/model/User.js